var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandardisedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_314_30",
    "data-name": "Component 314 \\u2013 30",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41111",
    "data-name": "Group 41111",
    transform: "translate(-57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41129",
    "data-name": "Group 41129",
    transform: "translate(10097 8120)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7986",
    "data-name": "Rectangle 7986",
    width: 148,
    height: 148,
    transform: "translate(-10040 -8120)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41763",
    "data-name": "Path 41763",
    d: "M73.512,315.4A6.512,6.512,0,1,1,67,321.911a6.512,6.512,0,0,1,6.512-6.512",
    transform: "translate(-10007.839 -8341.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41764",
    "data-name": "Path 41764",
    d: "M70.232,308a1.333,1.333,0,1,1-1.332,1.332A1.331,1.331,0,0,1,70.232,308",
    transform: "translate(-10006.927 -8345.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41766",
    "data-name": "Path 41766",
    d: "M65.768,298.032H56V285.6a13.319,13.319,0,0,1,9.769,12.432",
    transform: "translate(-10013.119 -8355.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41767",
    "data-name": "Path 41767",
    d: "M60.232,323a1.333,1.333,0,1,1-1.332,1.332A1.331,1.331,0,0,1,60.232,323",
    transform: "translate(-10011.727 -8337.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41770",
    "data-name": "Path 41770",
    d: "M54.7,286.1a3.7,3.7,0,1,0,3.7,3.7,3.664,3.664,0,0,0-3.7-3.7",
    transform: "translate(-10015.519 -8355.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41771",
    "data-name": "Path 41771",
    d: "M53.932,287.6a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10014.751 -8354.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41772",
    "data-name": "Path 41772",
    d: "M54.268,289.892v8.14H44.5A13.65,13.65,0,0,1,54.268,285.6Z",
    transform: "translate(-10018.639 -8355.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41774",
    "data-name": "Path 41774",
    d: "M47.432,310.2a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10017.871 -8344.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41775",
    "data-name": "Path 41775",
    d: "M48.588,321.747a2.742,2.742,0,1,1,.148,5.476H32.012a2.828,2.828,0,0,1-2.072-4.736,2.936,2.936,0,0,1,1.924-.888H48.588Z",
    transform: "translate(-10025.983 -8338.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41776",
    "data-name": "Path 41776",
    d: "M41.3,318.887v25.9H33.9V277.3a3.7,3.7,0,1,1,7.4,0v41.588Z",
    transform: "translate(-10023.727 -8361.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41777",
    "data-name": "Path 41777",
    d: "M30.232,294.9a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10026.127 -8351.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41778",
    "data-name": "Path 41778",
    d: "M27.6,287.9a3.7,3.7,0,1,1-3.7,3.7,3.759,3.759,0,0,1,3.7-3.7",
    transform: "translate(-10028.527 -8354.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41779",
    "data-name": "Path 41779",
    d: "M27.732,278.6a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10027.327 -8359.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41780",
    "data-name": "Path 41780",
    d: "M25.632,311.7a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10028.335 -8343.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41781",
    "data-name": "Path 41781",
    d: "M39.188,331.276a.956.956,0,0,1-.888-.889v-25.9a.888.888,0,0,1,1.776,0v25.9a.854.854,0,0,1-.888.889",
    transform: "translate(-10021.615 -8347.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41782",
    "data-name": "Path 41782",
    d: "M34.188,345.964a.956.956,0,0,1-.888-.889V277.588a4.588,4.588,0,1,1,9.176,0v1.924a.888.888,0,1,1-1.776,0v-1.924a2.81,2.81,0,0,0-2.812-2.812,2.721,2.721,0,0,0-2.812,2.812v67.487a.854.854,0,0,1-.888.889",
    transform: "translate(-10024.015 -8361.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41783",
    "data-name": "Path 41783",
    d: "M48.876,328.5a.888.888,0,0,1,0-1.776,1.8,1.8,0,0,0,1.332-.594A1.872,1.872,0,0,0,50.8,324.8a1.959,1.959,0,0,0-1.924-1.924H32.3a1.808,1.808,0,0,0-1.332.592,1.876,1.876,0,0,0-.592,1.332,1.959,1.959,0,0,0,1.924,1.924.888.888,0,1,1,0,1.776,3.665,3.665,0,0,1-3.7-3.7,4.255,4.255,0,0,1,1.036-2.664A3.567,3.567,0,0,1,32.3,321.1H48.876a3.664,3.664,0,0,1,3.7,3.7,3.549,3.549,0,0,1-3.7,3.7",
    transform: "translate(-10026.271 -8338.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41784",
    "data-name": "Path 41784",
    d: "M61.488,334.076a.955.955,0,0,1-.888-.889V330.08a3.349,3.349,0,0,0-3.4-3.4H28.78a3.349,3.349,0,0,0-3.4,3.4v3.107a.888.888,0,1,1-1.776,0V330.08a5.243,5.243,0,0,1,5.18-5.18H57.2a5.244,5.244,0,0,1,5.18,5.18v3.107a.855.855,0,0,1-.889.889",
    transform: "translate(-10028.671 -8337.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41785",
    "data-name": "Path 41785",
    d: "M95.576,318.288H39.188a.956.956,0,0,1-.888-.888V277.588a.955.955,0,0,1,.888-.888H95.576a1.279,1.279,0,0,1,.888.444.931.931,0,0,1,0,.888L83,296.976,96.464,316.66c.148.148.148.3.148.592a1.012,1.012,0,0,1-1.036,1.036m-55.5-1.776H93.8L80.924,297.568a1.264,1.264,0,0,1,0-1.036L93.8,278.624H40.076Z",
    transform: "translate(-10021.615 -8360.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41786",
    "data-name": "Path 41786",
    d: "M91.664,331.676H23.288a.888.888,0,0,1,0-1.776H91.813a.955.955,0,0,1,.887.887,1.107,1.107,0,0,1-1.036.889",
    transform: "translate(-10029.247 -8334.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41787",
    "data-name": "Path 41787",
    d: "M66.069,299.225a.956.956,0,0,1-.889-.888A12.3,12.3,0,0,0,56,286.793a.934.934,0,0,1-.592-1.184c.147-.592.592-.74,1.184-.592A14.252,14.252,0,0,1,67.1,298.337a.991.991,0,0,1-1.036.888",
    transform: "translate(-10013.42 -8356.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41788",
    "data-name": "Path 41788",
    d: "M44.688,299.221h0a.853.853,0,0,1-.888-.888,14.542,14.542,0,0,1,10.508-13.32.936.936,0,1,1,.592,1.776,12.671,12.671,0,0,0-9.176,11.544,1.108,1.108,0,0,1-1.036.888",
    transform: "translate(-10018.975 -8356.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41789",
    "data-name": "Path 41789",
    d: "M72.192,301.048H45.848A3.918,3.918,0,0,1,42,297.2a3.706,3.706,0,0,1,1.184-2.664,3.492,3.492,0,0,1,2.368-1.036h9.916a.888.888,0,0,1,0,1.776h-9.62a1.827,1.827,0,0,0-1.184.592,1.9,1.9,0,0,0-.592,1.48,2.117,2.117,0,0,0,2.072,2.072H72.488a2.023,2.023,0,0,0,2.072-2.072,1.835,1.835,0,0,0-1.776-1.924H62.72a.888.888,0,1,1,0-1.776h9.916a3.3,3.3,0,0,1,3.4,3.552,3.706,3.706,0,0,1-1.184,2.664,3.466,3.466,0,0,1-2.664,1.184",
    transform: "translate(-10019.839 -8352.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41790",
    "data-name": "Path 41790",
    d: "M58.64,300.169H51.388a.956.956,0,0,1-.888-.89V283.888a.955.955,0,0,1,.888-.89H58.64a.955.955,0,0,1,.888.89v15.391a.956.956,0,0,1-.888.89m-6.364-1.778h5.476V284.775H52.276Z",
    transform: "translate(-10015.759 -8357.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41791",
    "data-name": "Path 41791",
    d: "M54.988,294.576a4.588,4.588,0,1,1,4.588-4.588,4.612,4.612,0,0,1-4.588,4.588m0-7.252a2.664,2.664,0,1,0,2.664,2.664,2.654,2.654,0,0,0-2.664-2.664",
    transform: "translate(-10015.808 -8355.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41792",
    "data-name": "Path 41792",
    d: "M73.8,329.6a7.4,7.4,0,1,1,7.4-7.4,7.328,7.328,0,0,1-7.4,7.4m0-12.876a5.624,5.624,0,1,0,5.624,5.624,5.622,5.622,0,0,0-5.624-5.624",
    transform: "translate(-10008.127 -8341.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41793",
    "data-name": "Path 41793",
    d: "M27.888,296.576a4.588,4.588,0,1,1,4.588-4.588,4.611,4.611,0,0,1-4.588,4.588m0-7.4a2.81,2.81,0,0,0-2.812,2.812,2.721,2.721,0,0,0,2.812,2.812,2.812,2.812,0,1,0,0-5.624",
    transform: "translate(-10028.815 -8355.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41794",
    "data-name": "Path 41794",
    d: "M78.112,281.676H39.188a.888.888,0,0,1,0-1.776H78.112a.888.888,0,1,1,0,1.776",
    transform: "translate(-10021.615 -8358.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41795",
    "data-name": "Path 41795",
    d: "M78.112,302.275H39.188a.888.888,0,1,1,0-1.776H78.112a.888.888,0,1,1,0,1.776",
    transform: "translate(-10021.615 -8348.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41798",
    "data-name": "Path 41798",
    d: "M70.232,308a1.333,1.333,0,1,1-1.332,1.332A1.331,1.331,0,0,1,70.232,308",
    transform: "translate(-10006.927 -8345.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41801",
    "data-name": "Path 41801",
    d: "M60.232,323a1.333,1.333,0,1,1-1.332,1.332A1.331,1.331,0,0,1,60.232,323",
    transform: "translate(-10011.727 -8337.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41805",
    "data-name": "Path 41805",
    d: "M53.932,287.6a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10014.751 -8354.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41808",
    "data-name": "Path 41808",
    d: "M47.432,310.2a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10017.871 -8344.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41129-2",
    "data-name": "Group 41129",
    transform: "translate(-10004.626 -8088.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41800",
    "data-name": "Path 41800",
    d: "M65.768,298.032H56V285.6a13.319,13.319,0,0,1,9.769,12.432",
    transform: "translate(-8.493 -267.839)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41804",
    "data-name": "Path 41804",
    d: "M54.7,286.1a3.7,3.7,0,1,0,3.7,3.7,3.664,3.664,0,0,0-3.7-3.7",
    transform: "translate(-10.893 -267.599)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41806",
    "data-name": "Path 41806",
    d: "M54.268,289.892v8.14H44.5A13.65,13.65,0,0,1,54.268,285.6Z",
    transform: "translate(-14.013 -267.839)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41809",
    "data-name": "Path 41809",
    d: "M48.588,321.747a2.742,2.742,0,1,1,.148,5.476H32.012a2.828,2.828,0,0,1-2.072-4.736,2.936,2.936,0,0,1,1.924-.888H48.588Z",
    transform: "translate(-21.357 -250.559)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41810",
    "data-name": "Path 41810",
    d: "M41.3,318.887v25.9H33.9V277.3a3.7,3.7,0,1,1,7.4,0v41.588Z",
    transform: "translate(-19.101 -273.599)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41797",
    "data-name": "Path 41797",
    d: "M73.512,315.4A6.512,6.512,0,1,1,67,321.911a6.512,6.512,0,0,1,6.512-6.512",
    transform: "translate(-3.213 -253.535)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41812",
    "data-name": "Path 41812",
    d: "M27.6,287.9a3.7,3.7,0,1,1-3.7,3.7,3.759,3.759,0,0,1,3.7-3.7",
    transform: "translate(-23.901 -266.735)",
    fill: "#4eb2a2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41811",
    "data-name": "Path 41811",
    d: "M30.232,294.9a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10026.127 -8351.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41813",
    "data-name": "Path 41813",
    d: "M27.732,278.6a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10027.327 -8359.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41814",
    "data-name": "Path 41814",
    d: "M25.632,311.7a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10028.335 -8343.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41815",
    "data-name": "Path 41815",
    d: "M39.188,331.276a.956.956,0,0,1-.888-.889v-25.9a.888.888,0,0,1,1.776,0v25.9a.854.854,0,0,1-.888.889",
    transform: "translate(-10021.615 -8347.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41816",
    "data-name": "Path 41816",
    d: "M34.188,345.964a.956.956,0,0,1-.888-.889V277.588a4.588,4.588,0,1,1,9.176,0v1.924a.888.888,0,1,1-1.776,0v-1.924a2.81,2.81,0,0,0-2.812-2.812,2.721,2.721,0,0,0-2.812,2.812v67.487a.854.854,0,0,1-.888.889",
    transform: "translate(-10024.015 -8361.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41817",
    "data-name": "Path 41817",
    d: "M48.876,328.5a.888.888,0,0,1,0-1.776,1.8,1.8,0,0,0,1.332-.594A1.872,1.872,0,0,0,50.8,324.8a1.959,1.959,0,0,0-1.924-1.924H32.3a1.808,1.808,0,0,0-1.332.592,1.876,1.876,0,0,0-.592,1.332,1.959,1.959,0,0,0,1.924,1.924.888.888,0,1,1,0,1.776,3.665,3.665,0,0,1-3.7-3.7,4.255,4.255,0,0,1,1.036-2.664A3.567,3.567,0,0,1,32.3,321.1H48.876a3.664,3.664,0,0,1,3.7,3.7,3.549,3.549,0,0,1-3.7,3.7",
    transform: "translate(-10026.271 -8338.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41818",
    "data-name": "Path 41818",
    d: "M61.488,334.076a.955.955,0,0,1-.888-.889V330.08a3.349,3.349,0,0,0-3.4-3.4H28.78a3.349,3.349,0,0,0-3.4,3.4v3.107a.888.888,0,1,1-1.776,0V330.08a5.243,5.243,0,0,1,5.18-5.18H57.2a5.244,5.244,0,0,1,5.18,5.18v3.107a.855.855,0,0,1-.889.889",
    transform: "translate(-10028.671 -8337.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41819",
    "data-name": "Path 41819",
    d: "M95.576,318.288H39.188a.956.956,0,0,1-.888-.888V277.588a.955.955,0,0,1,.888-.888H95.576a1.279,1.279,0,0,1,.888.444.931.931,0,0,1,0,.888L83,296.976,96.464,316.66c.148.148.148.3.148.592a1.012,1.012,0,0,1-1.036,1.036m-55.5-1.776H93.8L80.924,297.568a1.264,1.264,0,0,1,0-1.036L93.8,278.624H40.076Z",
    transform: "translate(-10021.615 -8360.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41820",
    "data-name": "Path 41820",
    d: "M91.664,331.676H23.288a.888.888,0,0,1,0-1.776H91.813a.955.955,0,0,1,.887.887,1.107,1.107,0,0,1-1.036.889",
    transform: "translate(-10029.247 -8334.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41821",
    "data-name": "Path 41821",
    d: "M66.069,299.225a.956.956,0,0,1-.889-.888A12.3,12.3,0,0,0,56,286.793a.934.934,0,0,1-.592-1.184c.147-.592.592-.74,1.184-.592A14.252,14.252,0,0,1,67.1,298.337a.991.991,0,0,1-1.036.888",
    transform: "translate(-10013.42 -8356.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41822",
    "data-name": "Path 41822",
    d: "M44.688,299.221h0a.853.853,0,0,1-.888-.888,14.542,14.542,0,0,1,10.508-13.32.936.936,0,1,1,.592,1.776,12.671,12.671,0,0,0-9.176,11.544,1.108,1.108,0,0,1-1.036.888",
    transform: "translate(-10018.975 -8356.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41823",
    "data-name": "Path 41823",
    d: "M72.192,301.048H45.848A3.918,3.918,0,0,1,42,297.2a3.706,3.706,0,0,1,1.184-2.664,3.492,3.492,0,0,1,2.368-1.036h9.916a.888.888,0,0,1,0,1.776h-9.62a1.827,1.827,0,0,0-1.184.592,1.9,1.9,0,0,0-.592,1.48,2.117,2.117,0,0,0,2.072,2.072H72.488a2.023,2.023,0,0,0,2.072-2.072,1.835,1.835,0,0,0-1.776-1.924H62.72a.888.888,0,1,1,0-1.776h9.916a3.3,3.3,0,0,1,3.4,3.552,3.706,3.706,0,0,1-1.184,2.664,3.466,3.466,0,0,1-2.664,1.184",
    transform: "translate(-10019.839 -8352.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41824",
    "data-name": "Path 41824",
    d: "M58.64,300.169H51.388a.956.956,0,0,1-.888-.89V283.888a.955.955,0,0,1,.888-.89H58.64a.955.955,0,0,1,.888.89v15.391a.956.956,0,0,1-.888.89m-6.364-1.778h5.476V284.775H52.276Z",
    transform: "translate(-10015.759 -8357.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41825",
    "data-name": "Path 41825",
    d: "M54.988,294.576a4.588,4.588,0,1,1,4.588-4.588,4.612,4.612,0,0,1-4.588,4.588m0-7.252a2.664,2.664,0,1,0,2.664,2.664,2.654,2.654,0,0,0-2.664-2.664",
    transform: "translate(-10015.808 -8355.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41826",
    "data-name": "Path 41826",
    d: "M73.8,329.6a7.4,7.4,0,1,1,7.4-7.4,7.328,7.328,0,0,1-7.4,7.4m0-12.876a5.624,5.624,0,1,0,5.624,5.624,5.622,5.622,0,0,0-5.624-5.624",
    transform: "translate(-10008.127 -8341.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41827",
    "data-name": "Path 41827",
    d: "M27.888,296.576a4.588,4.588,0,1,1,4.588-4.588,4.611,4.611,0,0,1-4.588,4.588m0-7.4a2.81,2.81,0,0,0-2.812,2.812,2.721,2.721,0,0,0,2.812,2.812,2.812,2.812,0,1,0,0-5.624",
    transform: "translate(-10028.815 -8355.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41828",
    "data-name": "Path 41828",
    d: "M78.112,281.676H39.188a.888.888,0,0,1,0-1.776H78.112a.888.888,0,1,1,0,1.776",
    transform: "translate(-10021.615 -8358.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41829",
    "data-name": "Path 41829",
    d: "M78.112,302.275H39.188a.888.888,0,1,1,0-1.776H78.112a.888.888,0,1,1,0,1.776",
    transform: "translate(-10021.615 -8348.719)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardisedLight);
export default __webpack_public_path__ + "static/media/standardised_light.8e9cf3de46a3787b18ebf3f6b0ea0924.svg";
export { ForwardRef as ReactComponent };